import { BlogCardSkeleton } from '@/pages/site/blog-page/components/news-card';

export function BlogDetailsPageSkeleton() {
  return (
    <div className="bg-[#f7f7fa] text-[#17141f]">
      <section className="mt-24 bg-white py-10 sm:py-20">
        <div className="app-container">
          <div className="mx-auto">
            <div className="mx-auto flex max-w-[980px] animate-pulse flex-col items-center text-center">
              <div className="h-9 w-full max-w-[920px] rounded-full bg-[#ececf2] sm:h-12" />
              <div className="mt-3 h-9 w-[88%] max-w-[820px] rounded-full bg-[#ececf2] sm:h-12" />
              <div className="mt-6 h-5 w-[72%] max-w-[760px] rounded-full bg-[#ececf2] sm:mt-8 sm:h-6" />
              <div className="mt-3 h-5 w-[58%] max-w-[620px] rounded-full bg-[#ececf2] sm:h-6" />
            </div>

            <div className="mt-8 grid gap-8 sm:mt-14 lg:grid-cols-[441px_minmax(0,1fr)]">
              <div className="order-2 h-[460px] animate-pulse rounded-[20px] border border-[#eeeaf3] bg-white shadow-[0px_12px_24px_0px_#0000000a] sm:h-[574px] sm:rounded-[24px] lg:order-1">
                <div className="border-b border-[#efeff4] px-4 py-4 sm:px-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="h-10 w-10 rounded-full bg-[#ececf2] sm:h-12 sm:w-12" />
                      <div>
                        <div className="h-5 w-20 rounded-full bg-[#ececf2] sm:h-6 sm:w-24" />
                        <div className="mt-2 h-4 w-20 rounded-full bg-[#ececf2]" />
                      </div>
                    </div>
                    <div className="h-6 w-6 rounded-full bg-[#ececf2]" />
                  </div>
                </div>
                <div className="space-y-6 px-4 py-5 sm:px-6 sm:py-6">
                  <div className="h-32 rounded-[18px] bg-[#ececf2] sm:h-48" />
                  <div className="ml-auto h-16 w-20 rounded-[16px] bg-[#ececf2]" />
                </div>
                <div className="mt-auto px-4 pt-4 sm:px-6">
                  <div className="h-14 rounded-[16px] bg-[#ececf2]" />
                  <div className="mx-auto mt-4 h-4 w-48 rounded-full bg-[#ececf2]" />
                </div>
              </div>

              <div className="order-1 aspect-video animate-pulse rounded-2xl bg-[#ececf2] sm:aspect-auto sm:h-[574px] sm:rounded-3xl lg:order-2" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white">
        <div className="app-container border-t border-dashed border-[#e4e2e8] py-8 sm:py-12 lg:py-16">
          <div className="grid gap-8 sm:gap-12 lg:grid-cols-[400px_1fr] lg:gap-16">
            <div className="animate-pulse">
              <div className="mb-10 h-6 w-20 rounded-full bg-[#ececf2]" />
              <div className="border-b border-[#f1dfd8] pb-4 sm:pb-6">
                <div className="mb-4 h-5 w-28 rounded-full bg-[#ececf2]" />
                <div className="flex items-center gap-4">
                  <div className="h-10 w-10 rounded-full bg-[#ececf2] sm:h-[56px] sm:w-[56px]" />
                  <div className="flex-1">
                    <div className="h-5 w-32 rounded-full bg-[#ececf2] sm:h-6" />
                    <div className="mt-2 h-4 w-36 rounded-full bg-[#ececf2] sm:mt-3 sm:h-5 sm:w-40" />
                  </div>
                </div>
              </div>
              <div className="border-b border-[#f1dfd8] py-4 sm:py-6">
                <div className="mb-4 h-5 w-16 rounded-full bg-[#ececf2]" />
                <div className="flex gap-3">
                  <div className="h-9 w-20 rounded-full bg-[#ececf2] sm:h-10 sm:w-24" />
                  <div className="h-9 w-20 rounded-full bg-[#ececf2] sm:h-10 sm:w-24" />
                </div>
              </div>
              <div className="py-4 sm:py-8">
                <div className="mb-5 h-5 w-16 rounded-full bg-[#ececf2]" />
                <div className="flex gap-5">
                  <div className="h-6 w-6 rounded-full bg-[#ececf2]" />
                  <div className="h-6 w-6 rounded-full bg-[#ececf2]" />
                  <div className="h-6 w-6 rounded-full bg-[#ececf2]" />
                  <div className="h-6 w-6 rounded-full bg-[#ececf2]" />
                </div>
              </div>
            </div>

            <div className="animate-pulse">
              <div className="mb-5 h-7 w-64 max-w-full rounded-full bg-[#ececf2] sm:h-8 sm:w-80" />
              <div className="mb-4 h-5 w-full rounded-full bg-[#ececf2] sm:h-6" />
              <div className="mb-4 h-5 w-[90%] rounded-full bg-[#ececf2] sm:h-6" />
              <div className="mb-4 h-5 w-[84%] rounded-full bg-[#ececf2] sm:h-6" />
              <div className="mb-8 h-20 w-[88%] rounded-full bg-[#ececf2] sm:h-24" />
              <div className="mb-5 h-7 w-60 max-w-full rounded-full bg-[#ececf2] sm:h-8 sm:w-72" />
              <div className="mb-4 h-5 w-full rounded-full bg-[#ececf2] sm:h-6" />
              <div className="mb-4 h-5 w-[92%] rounded-full bg-[#ececf2] sm:h-6" />
              <div className="mb-4 h-5 w-[86%] rounded-full bg-[#ececf2] sm:h-6" />
              <div className="h-32 w-[90%] rounded-full bg-[#ececf2] sm:h-40" />
            </div>
          </div>
        </div>
      </section>

      <section className="sm:py-18 bg-[#f6f6f8] py-14 lg:py-20">
        <div className="app-container">
          <div className="mb-8 h-9 w-60 animate-pulse rounded-full bg-[#ececf2] sm:h-12 sm:w-72" />
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 3 }, (_, index) => (
              <BlogCardSkeleton key={index} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
